import React from "react";
import { useVenue } from "./VenueContext";
import { Button } from "./Atoms";

const OnlineMenuMessage = ({ onDismiss }: { onDismiss: () => void }) => {
  const venue = useVenue();
  const { activeMenuMessage } = venue.venueBrand;
  if (!activeMenuMessage) return null;
  return (
    <div className="max-w-sm mx-auto w-full space-y-16 bg-venue-secondary rounded-venue-brand p-12">
      <div className="flex">
        <div className="flex-1 text-xl ">{activeMenuMessage.title}</div>
      </div>
      <div className="min-h-[96px] whitespace-pre-line ">
        {activeMenuMessage.message}
      </div>
      <div>
        <Button primary onClick={onDismiss}>
          {activeMenuMessage.confirmationText}
        </Button>
      </div>
    </div>
  );
};

export default OnlineMenuMessage;
